export async function exchangeCodeManually(code: string, redirectUri: string, codeVerifier?: string) {
    const authority = process.env.REACT_APP_LOGIN_URL;
    const tokenEndpoint = `${authority}/connect/token`;

    // Prepare the form data
    const formData = new URLSearchParams();
    formData.append('client_id', 'pw3-a');
    formData.append('grant_type', 'authorization_code');
    formData.append('code', code);
    formData.append('redirect_uri', redirectUri);

    // If you're using PKCE (which you should be)
    if (codeVerifier) {
      formData.append('code_verifier', codeVerifier);
    }

    // Make the request
    const response = await fetch(tokenEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        // If using client_secret_basic auth:
        // 'Authorization': 'Basic ' + btoa('your-client-id:your-client-secret')
      },
      body: formData
    });

    if (!response.ok) {
      throw new Error(`Token exchange failed: ${response.status} ${response.statusText}`);
    }

    // Parse and return the tokens
    const tokens = await response.json();
    return tokens;
    // Returns { access_token, id_token, refresh_token, expires_in, token_type, etc. }
  }

export async function getUserInfo(accessToken: string) {
    const authority = process.env.REACT_APP_LOGIN_URL;
    const userInfoEndpoint = `${authority}/connect/userinfo`;

    const response = await fetch(userInfoEndpoint, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Accept': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error(`Failed to get user info: ${response.status} ${response.statusText}`);
    }

    const userInfo = await response.json();
    return userInfo;
    // Returns user information like { sub, name, email, etc. }
}
